var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroup7 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C76306",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.364 6H1.636C.733 6 0 6.767 0 7.714v12.572C0 21.233.733 22 1.636 22h2.728C5.267 22 6 21.233 6 20.286V7.714C6 6.767 5.267 6 4.364 6zM1.636 20.286h2.728V7.714H1.636v12.572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.242 0c-1.69 0-2.575 1.66-2.575 3.3v1.516l-1.86 1.986-2.738.947C5.432 7.969 5 8.604 5 9.319v8.831c0 .552.258 1.066.688 1.373l3.091 2.2c.254.18.552.277.857.277h9.788C20.844 22 22 20.766 22 19.25v-.55c0-.3-.075-.582-.207-.825.132-.243.207-.524.207-.825V15.4c0-.3-.075-.582-.207-.825.132-.243.207-.524.207-.825V12.1c0-.3-.075-.582-.207-.825.132-.243.207-.524.207-.825V9.9c0-1.516-1.155-2.75-2.576-2.75H15.82V3.3c0-1.64-.885-3.3-2.577-3.3m0 1.65c1.03 0 1.03 1.65 1.03 1.65v5.5H19.425c.569 0 1.03.493 1.03 1.1v.55h-.772c-.427 0-.773.37-.773.825 0 .455.346.825.773.825h.773v1.65h-.773c-.427 0-.773.37-.773.825 0 .455.346.825.773.825h.773v1.65h-.773c-.427 0-.773.37-.773.825 0 .455.346.825.773.825h.773v.55c0 .607-.462 1.1-1.03 1.1H9.635l-3.09-2.2V9.318l3.09-1.069L12.212 5.5V3.3s0-1.65 1.03-1.65"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup7, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group-7.68432e3b.svg";
export { ForwardRef as ReactComponent };